import RecoversPossessionSetting from "./recovers-possession-setting";

export default class Transition {
    constructor({
        name,
        displayName,
        keyStroke,
        icon,
        order,
        disabled,
        recoversPossession = RecoversPossessionSetting.Unset,
        showInToolbar
    }) {
        Object.assign(this, {
            name,
            displayName,
            keyStroke,
            icon,
            order,
            disabled,
            recoversPossession,
            showInToolbar
        });
    }
}
